<footer id="footer">
    <span id="app-copyright" i18n="Voatz copyright">© {{year}} Voatz™, Inc. All Rights Reserved.</span>
    <span id="app-version-number" i18n="Version number for the part of the app that runs in the browser">Version {{appVersion}}</span>
  <span id="app-footer-links">
  <a i18n="Link to Privacy Policy page" id="app-footer-privacy-link" i18n-href="Language specific url for Privacy Policy page" target="_blank" href="https://voatz.com/privacy/">Privacy</a>&nbsp;|&nbsp;<a i18n="Link to Terms of Service page" i18n-href="Language specific url for Terms of Service page" id="app-footer-terms-link" target="_blank" href="https://voatz.com/legal/">Terms</a>
  </span>  
</footer>
